<template>
  <div class="text-center">
    <section v-if="!vencida">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            style="cursor: pointer"
            v-bind="attrs"
            v-on="on"
            :disabled="isLoadingBtn"
            @click="baixarDae()"
            color="primary"
            >download</v-icon
          >
        </template>
        <span>Baixar DAE</span>
      </v-tooltip>
    </section>
    <v-dialog v-else v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-tooltip top>
          <template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
            <v-icon
              style="cursor: pointer"
              v-bind="{ ...attrs, ...attrsTooltip }"
              v-on="{ ...on, ...onTooltip }"
              color="primary"
              >download</v-icon
            >
          </template>
          <span>Taxa vencida - selecione uma nova data de vencimento</span>
        </v-tooltip>
      </template>

      <v-card>
        <v-toolbar color="primary" class="text-h6 elevation-0" dark>
          Taxa vencida - selecione a nova data de vencimento
        </v-toolbar>
        <v-card-text class="pa-10">
          <v-text-field
            v-model="dateVencimento"
            v-mask="'##/##/####'"
            label="Nova Data de Vencimento"
            placeholder="DD/MM/AAAA"
            :error-messages="dateVencimentoErrors"
            clearable
            outlined
          ></v-text-field>
          <v-date-picker
            v-model="vencimento.date"
            :min="dateMin"
            full-width
          ></v-date-picker>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="dialog = false"> Cancelar </v-btn>

          <v-spacer></v-spacer>
          <v-btn
            :disabled="!vencimento.date"
            color="primary"
            text
            @click="baixarDae()"
            :loading="isLoadingBtn"
          >
            GERAR DAE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import taxaRegulacaoService from '@/services/financeiro/taxa-regulacao.service';

export default {
  name: 'DialogBaixarDaeTaxaRegulacao',
  props: {
    idReceita: { type: [String, Number], required: true },
    cpfCnpj: { type: String, default: '' },
    dataVencimento: { type: String, default: '' },
  },
  data() {
    return {
      dialog: false,
      vencimento: {
        date: null,
      },
      invalidInput: null,
      isLoadingBtn: false,
    };
  },
  computed: {
    vencida() {
      return this.checkValidade(this.dataVencimento);
    },
    dateVencimento: {
      get() {
        if (this.vencimento.date) return moment(this.vencimento.date).format('DD/MM/YYYY');
        return this.invalidInput || '';
      },
      set(value) {
        const parsed = moment(value, 'DD/MM/YYYY', true);
        const isValidFutureDate = parsed.isValid() && !parsed.isBefore(moment(), 'day');
        this.vencimento.date = isValidFutureDate ? parsed.format('YYYY-MM-DD') : null;
        this.invalidInput = isValidFutureDate ? null : value;
      },
    },
    dateVencimentoErrors() {
      if (!this.invalidInput || this.invalidInput.length < 10) return [];
      const parsed = moment(this.invalidInput, 'DD/MM/YYYY', true);
      if (!parsed.isValid()) return ['Data inválida'];
      return ['A data deve ser igual ou posterior a hoje'];
    },
    dateMin() {
      return moment().format('YYYY-MM-DD');
    },
  },
  methods: {
    checkValidade(dataVencimento) {
      if (!dataVencimento) return false;
      const date = moment(dataVencimento).format('YYYY-MM-DD');
      return moment(date).isBefore(moment(), 'day');
    },
    baixarDae() {
      const date = this.vencida ? this.vencimento.date : null;

      if (this.vencida && !date) return;

      this.isLoadingBtn = true;
      taxaRegulacaoService.baixarDae(this.cpfCnpj, [this.idReceita.toString()], date).subscribe(
        res => {
          const file = new Blob([res], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.isLoadingBtn = false;
          this.vencimento = { date: null };
          this.invalidInput = null;
          this.dialog = false;
          if (this.vencida) this.$emit('dae-gerado');
        },
        () => {
          this.isLoadingBtn = false;
        }
      );
    },
  },
};
</script>
